/* eslint-disable import/prefer-default-export */
import types from '../types/types';

export const getReferralFromURL = (referralId, referralName) => (dispatch) => {
  dispatch({
    type: types.referralFromUrl,
    referralId,
    referralName,
  });
};
